import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-243a5317"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "scroll-area container-fluid"
}
const _hoisted_2 = { class: "search-wrapper my-3 mx-1" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "messages-scroller"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  class: "messages-scroller",
  ref: "chscroller"
}
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { class: "messages-scroller" }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = { class: "messages-scroller" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = {
  key: 1,
  class: "container-fluid"
}
const _hoisted_15 = { class: "mb-5" }
const _hoisted_16 = { class: "actions d-flex" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "my-5" }, "Hvis du allerede har konto", -1))
const _hoisted_18 = { class: "mt-3 actions d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadcrumbsBar = _resolveComponent("BreadcrumbsBar")!
  const _component_Close = _resolveComponent("Close")!
  const _component_Magnify = _resolveComponent("Magnify")!
  const _component_Dot = _resolveComponent("Dot")!
  const _component_MessageBubble = _resolveComponent("MessageBubble")!
  const _component_PendingGroupBubble = _resolveComponent("PendingGroupBubble")!
  const _component_GroupBubble = _resolveComponent("GroupBubble")!
  const _component_PlusCircleOutline = _resolveComponent("PlusCircleOutline")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_group_modal = _resolveComponent("group-modal")!
  const _component_profile_sheet = _resolveComponent("profile-sheet")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_BreadcrumbsBar, {
      title: _ctx.t('home'),
      image: "true"
    }, null, 8, ["title"]),
    (_ctx.userStore.getters.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("form", {
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.filterList && _ctx.filterList(...args)), ["prevent"])),
            class: "searchList"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("a", {
                class: "action",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)), ["prevent"]))
              }, [
                _createVNode(_component_Close, { class: "i" })
              ]),
              _createVNode(_component_Magnify, { class: "icon search-close" }),
              _createElementVNode("input", {
                type: "text",
                ref: "query",
                class: "form-control border-0",
                placeholder: _ctx.t('search')
              }, null, 8, _hoisted_3)
            ])
          ], 32),
          (_ctx.state.messages && _ctx.state.messages.length > 0)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_4, [
                _createVNode(_component_Dot, { class: "dot" }),
                _createTextVNode(" " + _toDisplayString(_ctx.t('searchresult')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.messages && _ctx.state.messages.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_TransitionGroup, {
                  tag: "ul",
                  name: "list",
                  appear: "",
                  id: "new-messages",
                  class: "new-messages scrollbox",
                  ref: "scr"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.messages, (msg) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: msg.id,
                        class: "message"
                      }, [
                        _createVNode(_component_MessageBubble, {
                          msg: msg,
                          "link-to-channel": true,
                          showChannel: true,
                          onShowProfile: _ctx.showProfile,
                          limitheight: "true"
                        }, null, 8, ["msg", "onShowProfile"])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 512)
              ]))
            : _createCommentVNode("", true),
          (_ctx.messageStore.getters.latest && _ctx.messageStore.getters.latest.length > 0)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_6, [
                _createVNode(_component_Dot, { class: "dot" }),
                _createTextVNode(" " + _toDisplayString(_ctx.t('networknews')), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_TransitionGroup, {
              tag: "ul",
              name: "list",
              appear: "",
              id: "new-messages",
              class: "new-messages scrollbox",
              ref: "scr"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageStore.getters.latest, (msg) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: msg.id,
                    class: "message"
                  }, [
                    _createVNode(_component_MessageBubble, {
                      msg: msg,
                      "link-to-channel": true,
                      showChannel: true,
                      onShowProfile: _ctx.showProfile,
                      limitheight: true
                    }, null, 8, ["msg", "onShowProfile"])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 512)
          ], 512),
          (_ctx.channelStore.getters.pending && _ctx.channelStore.getters.pending.length > 0)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_8, [
                _createVNode(_component_Dot, { class: "dot" }),
                _createTextVNode(" " + _toDisplayString(_ctx.t('networkpending')), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_TransitionGroup, {
              tag: "ul",
              name: "list",
              appear: "",
              id: "pending-groups",
              class: "groups scrollbox"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelStore.getters.pending, (pchan) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: pchan.id,
                    class: ""
                  }, [
                    _createVNode(_component_PendingGroupBubble, {
                      channel: pchan,
                      date: false,
                      count: false
                    }, null, 8, ["channel"])
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          (_ctx.channelStore.getters.suggestedChannels && _ctx.channelStore.getters.suggestedChannels.length > 0)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_10, [
                _createVNode(_component_Dot, { class: "dot" }),
                _createTextVNode(" " + _toDisplayString(_ctx.t('suggested')), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_TransitionGroup, {
              tag: "ul",
              name: "list",
              appear: "",
              id: "groups",
              class: "groups scrollbox",
              ref: "scr"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelStore.getters.suggestedChannels, (channel) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: channel.id,
                    class: "channel"
                  }, [
                    _createVNode(_component_GroupBubble, {
                      channel: channel,
                      date: false,
                      link: false,
                      count: true
                    }, null, 8, ["channel"])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 512)
          ]),
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.t('teaser')), 1),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "btn btn-rounded btn-primary mt-2 mb-5 mx-auto d-block text-nowrap",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.newChannel()))
            }, [
              _createVNode(_component_PlusCircleOutline, { class: "pencil" }),
              _createTextVNode(" " + _toDisplayString(_ctx.t('createnetwork')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.userStore.getters.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("h2", _hoisted_15, _toDisplayString(_ctx.t('newhere')), 1),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_router_link, {
              class: "d-block mx-auto btn btn-rounded btn-primary",
              to: "/signup"
            }, {
              default: _withCtx(() => [
                _createTextVNode("opprett konto")
              ]),
              _: 1
            })
          ]),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_router_link, {
              class: "d-block mx-auto btn btn-rounded btn-dark",
              to: "/login"
            }, {
              default: _withCtx(() => [
                _createTextVNode("logg inn")
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_group_modal, { ref: "mymodal" }, null, 512),
    _createVNode(_component_profile_sheet, { ref: "profileSheet" }, null, 512)
  ]))
}